import React from 'react';
import 'index.scss';

import { Outlet, createBrowserRouter, RouterProvider } from 'react-router-dom';

import Checkout from '@/pages/Checkout';
import Success from '@/pages/Success';
import Error from '@/pages/Error';
import Unavailable from '@/pages/Invalid';
import Processing from '@/pages/Processing';
import Redirect from '@/pages/Redirect';
import Antifraud from '@/pages/Antifraud';

function MainRoutes() {
  const routes = createBrowserRouter([
    {
      path: '/',
      element: <Outlet />,
      children: [
        {
          path: '/:id',
          element: <Checkout />,
        },
      ],
    },
    {
      path: '/:id/antifraud',
      element: <Antifraud />,
    },
    {
      path: '/success',
      element: <Outlet />,
      children: [
        {
          index: true,
          element: <Success />,
        },
        {
          path: ':id',
          element: <Success />,
        },
      ],
    },
    {
      path: '/error',
      element: <Outlet />,
      children: [
        {
          index: true,
          element: <Error />,
        },
        {
          path: ':id',
          element: <Error />,
        },
      ],
    },
    {
      path: '/unavailable',
      element: <Unavailable />,
    },
    {
      path: '/processing/:id',
      element: <Processing />,
    },
    {
      path: '/:id/redirect',
      element: <Redirect />,
    },
  ]);

  return <RouterProvider router={routes} />;
}

export default MainRoutes;
